import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
export interface OtpParams {
  otp: string;
  event: string;
}

export interface OtpState {
  errorMessage: string;
  isLoading: boolean;
  countdown: number;
  isCountdownActive: boolean;
  isAccountBlocked: boolean;
  isSuspendAccount: boolean;
  isEventFromInvitation: boolean;
  isVeritifyOtpSuccess?: boolean;
  otpToken: string;
  resendDelaySeconds?: number;
}
@Injectable()
export abstract class OtpStoreFactory {
  abstract vm$: Observable<OtpState>;
  abstract verifyOtp(otpParams: OtpParams): void;
  abstract resendOtp(params: { event: string; twoFactorAuthMethod?: string }): void;
  abstract startCountdown(): void;
  abstract setResendDelaySeconds(seconds: number): void;
  abstract getEmail(): string;
  abstract resetState(): void;
  abstract saveOtpSession(): void;
  abstract loadOtpSession(): boolean;
  abstract clearOtpSession(): void;
  abstract hasActiveSession(): boolean;
  abstract setInitialSession(token: string, resendDelaySeconds: number): void;
}
